import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './localization/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
        lang: localStorage.getItem('locale') || 'ru',
        loading: false,
        taxpayer: JSON.parse(localStorage.getItem('taxpayer') || '{}'),
        taxOrganizations: JSON.parse(localStorage.getItem('taxOrganizations') || '[]'),
        tokenExpiryDate: localStorage.getItem('tokenExpiryDate') != null ? new Date(localStorage.getItem('tokenExpiryDate')) : null
    },
    getters: {
        isLoading: state => {
            return state.loading
        },
        locale: state => {
            i18n.locale = state.lang
            return state.lang
        },
        isLoggedIn: (state) => {
            return Object.keys(state.userInfo).length > 0
        },
        getUserId: state => state.userInfo.id,
        getUserRole: (state) => {
            return state.userInfo ? (state.userInfo.role || '').toString() : ''
        },
        getUserName: state => {
            return state.userInfo ? state.userInfo.login : ''
        },
        getUserDisplayName: (state) => {
            return state.userInfo
                ? `${state.userInfo.surname} ${state.userInfo.firstName} ${state.userInfo.patronymic || ''}`
                : ''
        },
        firstName: (state) => {
            return state.userInfo ? state.userInfo.firstName : ''
        },
        lastName: (state) => {
            return state.userInfo ? state.userInfo.surname : ''
        },
        middleName: (state) => {
            return state.userInfo ? state.userInfo.patronymic : ''
        },
        getCurrentTaxpayer: state => {
            return Object.keys(state.taxpayer).length > 0 ? state.taxpayer : null
        },
        getTaxOrgs: (state) => {
            return state.taxOrganizations
        },
        getTaxOrgId: (state) => {
            return state.userInfo ? state.userInfo.taxorgid : null
        },
        pass: (state) => {
            return state.userInfo ? state.userInfo.password : null
        },
        token: s => s.userInfo ? s.userInfo.token : null,
        tokenExpiryDate: s => s.tokenExpiryDate
    },
    mutations: {
        toggleLoading (state) {
            state.loading = !state.loading
        },
        setLocale (state, data) {
            state.lang = data
            i18n.locale = state.lang
            localStorage.setItem('locale', data)
        },
        setUserInfo (state, data) {
            state.userInfo = data
            localStorage.setItem('userInfo', JSON.stringify(data))
        },
        setTaxpayer (state, data) {
            state.taxpayer = data
            localStorage.setItem('taxpayer', JSON.stringify(data || {}))
        },
        setTaxOrganizations (state, data) {
            state.taxOrganizations = data
            localStorage.setItem('taxOrganizations', JSON.stringify(data))
        },
        updateTokenExpiryDate(state, date) {
            state.tokenExpiryDate = date;
            localStorage.setItem('tokenExpiryDate', date.toString());
        },
        logout (state) {
            localStorage.removeItem('userInfo')
            localStorage.removeItem('locale')
            localStorage.removeItem('taxpayer')
            localStorage.removeItem('taxOrganizations')
            state.userInfo = {}
            state.taxpayer = {}
            localStorage.removeItem('tokenExpiryDate');
        }
    }
})
